/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_PrepInputs */

const en_today_prep = /** @type {(inputs: Today_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prep for tomorrow`)
};

const de_today_prep = /** @type {(inputs: Today_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für morgen vorbereiten`)
};

/**
* | output |
* | --- |
* | "Prep for tomorrow" |
*
* @param {Today_PrepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const today_prep = /** @type {((inputs?: Today_PrepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_PrepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_today_prep(inputs)
	return en_today_prep(inputs)
});